<template>
  <footer>
    <div class="center-container">
      <div class="footer-logo">
        <img src="../assets/img/logo.png" alt="Pousada Recanto da Família">
      </div>
      <div class="social-feed">
          <iframe src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2FPousada-Recanto-da-Fam%25C3%25ADlia-160577044045891%2F&width=450&layout=standard&action=like&size=large&show_faces=true&share=true&height=80&appId=2594438270583894" style="overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
      </div>
      <div class="footer-address">
        <address>
          <ul class="address">
            <li><i class="fab fa-whatsapp"></i> <a href="https://wa.me/5511974750184?text=Ol%C3%A1%2C%20estou%20entrando%20em%20contato%20pelo%20site%20da%20Pousada" target="_blank" alt="11 97475-0184">(11) 97475-0184</a></li>
            <li class="separator"><span></span></li>
            <li><i class="fas fa-map-marker-alt"></i> <a alt="Rod. João Hermenegildo de Oliveira, Km 8,5" href="https://www.google.com/maps/dir/?api=1&destination=Pousada+Recanto+da+Fam%C3%ADlia+-+Guaripocaba,+Bragan%C3%A7a+Paulista+-+SP" target="_blank">Rod. João Hermenegildo de Oliveira, Km 8,5</a></li>
            <li><a alt="Bragança Paulista - SP" href="https://www.google.com/maps/dir/?api=1&destination=Pousada+Recanto+da+Fam%C3%ADlia+-+Guaripocaba,+Bragan%C3%A7a+Paulista+-+SP" target="_blank">Bragança Paulista - SP</a></li>
            <li class="separator"><span></span></li>
            <li class="email-address"><i class="far fa-envelope"></i> con&#116;a&#116;o&#64;pousadar&#101;c&#97;n&#116;o&#100;&#97;fami&#108;i&#97;&#46;&#99;om&#46;br</li>
          </ul>
        </address>
        <div class="credits">
          <a href="https://mathvp.com.br" target="_blank">Desenvolvido por <span>Matheus Vieira</span><br>
          www.mathvp.com.br</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style>
.credits .addr {
  display: block;
  font-size: 1.2rem;
}
</style>
